/* eslint-disable no-lonely-if */
/* eslint-disable sonarjs/no-collapsible-if */
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";

import { isAfter } from "date-fns";
import Dialog from "../../components/Dialog";
import DialogMessage from "../../components/DialogMessage";
import HolidayParams from "../../model/HolidayParams";
import IModalProps from "../../model/ModalProps";
import SelectOption from "../../model/SelectOption";
import DialogStyles from "../../styles/components/DialogStyles";
import StringUtils from "../../utils/types/StringUtils";
import ModalFeriadoContent from "./modalContent/ModalFeriadoContent";
import ModalAbonoLoteContent from "./modalContent/ModalAbonoLoteContent";
import ModalGestaoAtividadesContent from "./modalContent/ModalGestaoAtividadesContent";
import { AutocompleteCombo } from "../../components/Autocomplete";
import ButtonStyles from "../../styles/components/ButtonStyles";
import GenericUtils from "../../utils/GenericUtils";

const registrationsAllowedForPastDates = ["18507", "30291"];

const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;

interface IModalSaveHolidayProps extends IModalProps {
    params?: HolidayParams;
    abono?: any;
    gestaoAtividades?: any;
    refresh?: () => Promise<void>;
}

const ABONO_LABEL = "Abono realizado pela administração";

const paramsOption: SelectOption[] = [
    { value: "1", label: "Recesso" },
    { value: "2", label: ABONO_LABEL },
    { value: "3", label: "Gestão de Atividades" },
];

const ModalSaveHoliday: React.FC<IModalSaveHolidayProps> = ({
    params,
    abono,
    gestaoAtividades,
    refresh,
    visibility,
    open,
    onClose,
}) => {
    const [openDialogQuestion, setOpenDialogQuestion] = useState(false);
    const [showDialog, setShowDialog] = useState(visibility ?? true);
    const [successMessage, setSuccessMessage] = useState("");
    const [typeParam] = useState<SelectOption[]>(paramsOption);
    const [type, setType] = useState<any[]>([]);
    const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
    const [errorMessage, setErrorMessage] = useState("");
    const [errorText, setErrorText] = useState<string | undefined>("");

    const translate = {
        operationFailure: StringUtils.translate("operationFailure"),
        operationSuccess: StringUtils.translate("operationSuccess"),
        titleInclude: StringUtils.translate("e6ff_TitleInclude"),
        titleEdit: StringUtils.translate("e6ff_TitleEdit"),
        labelType: StringUtils.translate("e6ff_LabelType"),
        labelName: StringUtils.translate("e6ff_LabelName"),
        labelCampus: StringUtils.translate("e6ff_LabelCampus"),
        labelDescription: StringUtils.translate("e6ff_LabelDescription"),
        btnSubmit: StringUtils.translate("e6ff_BtnSubmit"),
        btnCancel: StringUtils.translate("e6ff_BtnCancel"),
        dialogSuccessTitle: StringUtils.translate("e6ff_DialogSuccessTitle"),
        dialogQuestionTitle: StringUtils.translate("e6ff_DialogQuestionTitle"),
        dialogQuestionSubtitle: StringUtils.translate(
            "e6ff_DialogQuestionSubtitle"
        ),
        dialogQuestionBtnConfirm: StringUtils.translate(
            "e6ff_DialogQuestionBtnConfirm"
        ),
        dialogQuestionBtnCancel: StringUtils.translate(
            "e6ff_DialogQuestionBtnCancel"
        ),
    };

    const getDateByType = () => {
        if (type[0]?.value === "2") return params?.date;

        return params?.start;
    };

    const selectedDate = getDateByType();

    const handleCloseDialogQuestion = (callback: any) => {
        setOpenDialogQuestion(false);
        setShowDialog(visibility ?? true);
        if (callback?.confirmButton && onClose) onClose();
    };

    const handleCloseDialog = () => {
        setShowDialog(visibility ?? true);
        if (onClose && refresh) {
            refresh();
            onClose();
        }
    };

    const handleCloseDialogSuccess = () => {
        setSuccessMessage("");
        setShowDialog(visibility ?? true);
        if (onClose && refresh) {
            refresh();
            onClose();
        }
    };

    const validateCurrentDate = (selected: any) => {
        if (!selected || selected.length === 0) {
            setType([]);
            return;
        }

        const selectedValue = selected[0];

        if (
            selectedValue.label === ABONO_LABEL &&
            isAfter(new Date(), new Date(`${selectedDate}T23:59:59`)) &&
            !registrationsAllowedForPastDates.includes(
                GenericUtils.getUserAdp()
            )
        ) {
            setErrorMessage("Aviso");
            setErrorText(
                "Não é possível criar abonos administrativos para datas no passado."
            );
        } else {
            setType(selected);
        }
    };

    const DialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessage)}
            title={successMessage}
            onClose={handleCloseDialogSuccess}
        />
    );

    const formatedSelectedDate = moment(selectedDate).format("DD/MM/YYYY");

    const DialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            text={errorText}
            onClose={() => {
                setErrorMessage("");
                setErrorText("");
            }}
        />
    );

    useEffect(() => {
        if (params?.id) {
            if (abono) {
                setType([
                    { value: "2", label: "Abono realizado pela administração" },
                ]);
            } else if (gestaoAtividades && gestaoAtividades.isLoaded) {
                setType([{ value: "3", label: "Gestão de Atividades" }]);
            } else {
                if (params?.type !== "") {
                    setType([{ value: "1", label: "Recesso" }]);
                }
            }
        }
    }, [params?.id]);

    const DialogQuestion = (
        <DialogMessage
            type="question"
            show={openDialogQuestion}
            title={
                params?.id
                    ? "Deseja descartar a edição?"
                    : "Deseja descartar a inclusão?"
            }
            text={
                params?.id
                    ? "As informações editadas não serão salvas."
                    : "As informações não serão salvas."
            }
            textButton="Descartar"
            textButtonClose="Cancelar"
            onClose={handleCloseDialogQuestion}
        />
    );

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <>
            <Dialog
                openModal={open && successMessage === ""}
                onHide={() => setOpenDialogQuestion(true)}
                size="width-379"
                className={dialogClass}
            >
                <StyledModalTitle style={{ marginBottom: "10px" }}>
                    {params?.id
                        ? translate.titleEdit
                        : "Incluir datas extraordinárias"}
                </StyledModalTitle>
                <StyledModalTitle style={{ marginBottom: "25px" }}>
                    {formatedSelectedDate}
                </StyledModalTitle>
                <StyledModalText>
                    Você pode incluir recessos, abonos e gestão de atividades
                </StyledModalText>
                <Row>
                    <Col>
                        <AutocompleteCombo
                            label="Selecione o tipo de parâmetro"
                            options={typeParam}
                            selected={type}
                            onChange={validateCurrentDate}
                            placeholder="Selecione o tipo de parâmetro"
                            extraOptions
                        />
                    </Col>
                </Row>
                {type[0]?.value === "1" && (
                    <ModalFeriadoContent
                        open={type[0]?.value}
                        setOpenDialogQuestion={setOpenDialogQuestion}
                        params={params}
                        onClose={handleCloseDialog}
                        onSuccess={setSuccessMessage}
                    />
                )}
                {type[0]?.value === "2" && (
                    <ModalAbonoLoteContent
                        open={type[0]?.value}
                        setOpenDialogQuestion={setOpenDialogQuestion}
                        context={selectedDate}
                        onSuccess={setSuccessMessage}
                        abonoEdit={abono}
                    />
                )}
                {type[0]?.value === "3" && (
                    <ModalGestaoAtividadesContent
                        open={type[0]?.value}
                        setOpenDialogQuestion={setOpenDialogQuestion}
                        selectedDate={selectedDate}
                        onSuccess={setSuccessMessage}
                        gestaoAtividadesEdit={gestaoAtividades}
                    />
                )}
                {type.length === 0 && (
                    <div>
                        <StyledContainerButton>
                            <BtnPrimary disabled style={{ width: "50%" }}>
                                Salvar
                            </BtnPrimary>
                        </StyledContainerButton>
                        <StyledContainerButton>
                            <DefaultButtonLink
                                onClick={() => {
                                    setOpenDialogQuestion(true);
                                    setShowDialog(false);
                                }}
                            >
                                Cancelar
                            </DefaultButtonLink>
                        </StyledContainerButton>
                    </div>
                )}
            </Dialog>
            {DialogQuestion}
            {successMessage ? DialogSuccess : null}
            {openDialogQuestion ? DialogQuestion : null}
            {errorMessage && DialogError}
        </>
    );
};

export default ModalSaveHoliday;
